import { Trans } from "@lingui/react/macro";
import { useQuery } from "@tanstack/react-query";
import { Plus } from "lucide-react";
import { observer } from "mobx-react-lite";
import { useState } from "react";

import { apiGetPatientsByPatientIdMedicationsOptions } from "../../../api";
import { AppModel } from "../../../app/app-model";
import { Button } from "../../../components/ui-kit/button";
import { AddMedicationsDialog } from "../medications/add-medications-dialog";
import { MedicationsDataTable } from "../medications/medications-data-table";
import { Patient } from "../patient";

export const VisitMedicationsSection = observer(
  function VisitMedicationsSection(props: {
    app: AppModel;
    patient: Patient;
    onSaved?: () => void | Promise<void>;
  }) {
    const { app, patient, onSaved } = props;
    const [showAddDialog, setShowAddDialog] = useState(false);

    const { data: response, refetch } = useQuery(
      apiGetPatientsByPatientIdMedicationsOptions({
        path: { patient_id: patient.patientId },
      }),
    );
    const data = response?.medications ?? [];

    return (
      <div className="mb-4">
        <div className="flex items-center justify-between mb-2">
          <span className="text-sm font-semibold">
            <Trans>Current medications</Trans>
          </span>
          <Button size="sm" icon={Plus} onClick={() => setShowAddDialog(true)}>
            <Trans>Add medication</Trans>
          </Button>
        </div>

        <MedicationsDataTable
          api={patient.api}
          patient={patient}
          data={data}
          disableEdit
          disableHistory
          disablePagination
        />

        {showAddDialog && (
          <AddMedicationsDialog
            app={app}
            onClose={() => setShowAddDialog(false)}
            onSaved={() => {
              void refetch();
              void onSaved?.();
            }}
          />
        )}
      </div>
    );
  },
);
